<template>
  <WidgetLayout>
    <div class="flex justify-center">
      <div class="h-auto bg-white pb-2 w-96 md:w-[28rem]" :class="{ 'shadow-md rounded-xl': !generalStore.iFrame }">
        <div class="min-h-[680px] flex flex-col">
          <div class="px-3 m-0 flex flex-col flex-auto">
            <div v-if="!generalStore.iFrame" class="card-style text-center">
              <div class="flex justify-center mx-auto">
                <div
                  class="h-[2px] bg-gray-300 font-black border-0 relative top-[1.9em] w-20"
                  :class="currentStep > 0 ? 'bg-cyan-700' : 'bg-gray-300 '"
                ></div>
                <div
                  class="h-[2px] bg-gray-300 font-black border-0 relative top-[1.9em] w-20"
                  :class="currentStep > 1 ? 'bg-cyan-700' : 'bg-gray-300 '"
                ></div>
              </div>
              <div v-for="(step, index) in steps" :key="index" class="inline-grid gap-4">
                <div class="w-20 text-center m-2 items-center">
                  <div
                    class="size-10 rounded-full border-[1.5px] border-brand-600 text-center p-1.5 relative left-5"
                    :class="currentStep === index || index < currentStep ? 'bg-brand-600' : 'bg-base-white'"
                  >
                    <p v-if="index < currentStep" class="text-base-white">&#10003;</p>
                    <span
                      v-else
                      class="font-bold inline-block align-middle text-md"
                      :class="currentStep === index || index < currentStep ? 'text-base-white' : 'text-brand-600'"
                    >
                      {{ step.number }}
                    </span>
                  </div>
                  <span class="text-xs text-gray-500">{{ step.name }}</span>
                </div>
              </div>
            </div>
            <hr v-if="!generalStore.iFrame" class="h-px m-0 bg-gray-200 border-0 dark:bg-gray-300" />
            <div class="flex flex-col flex-auto card-style p-2">
              <RouterView />
            </div>
          </div>
          <PoweredBy />
        </div>
      </div>
    </div>
  </WidgetLayout>
</template>

<script setup lang="ts">
import PoweredBy from '@/components/common/PoweredBy.vue';
import WidgetLayout from '@/layouts/WidgetLayout.vue';
import { useWidgetStore } from '@/stores/widget';
import { hideFreshchatWhileOpen } from '@/utils/freshchat.utils';
import { ref, watch } from 'vue';
import { RouterView, useRoute, type RouteRecordName } from 'vue-router';
import { useGeneralStore } from '../stores/general';

const route = useRoute();
const generalStore = useGeneralStore();
const widgetStore = useWidgetStore();
const currentStep = ref(0);
const steps = ref([
  { name: 'Activate', number: '01' },
  { name: 'Sign In', number: '02' },
  { name: 'Payment', number: '03' },
]);

hideFreshchatWhileOpen();

const isSavingPlanScreen = route.name === 'BoostConfiguration' && widgetStore.boost.merchant?.voucherSettings?.active;
if (isSavingPlanScreen) {
  steps.value = [
    { name: 'Get started', number: '01' },
    { name: 'Sign In', number: '02' },
    { name: 'Start Saving', number: '03' },
  ];
}

if (route.query.notifyUrl) {
  widgetStore.notifyUrl = route.query.notifyUrl as string;
} else {
  widgetStore.notifyUrl = '';
}
currentStep.value = getStepByRoute(route.name);

watch(route, () => {
  currentStep.value = getStepByRoute(route.name);
});

function getStepByRoute(routeName: RouteRecordName | null | undefined) {
  const stepOneRoutes = [
    'WidgetSignIn',
    'WidgetSignUp',
    'OtpVerification',
    'ForgotPassword',
    'CreatePassword',
    'EnterEmail',
  ];
  const stepTwoRoutes = ['PeachPayment', 'SelectPaymentMethod', 'PayAt', 'DebiCheck', 'Contribute'];

  if (routeName === 'LayByConfiguration') return 0;
  if (stepOneRoutes.includes(routeName as string)) return 1;
  if (stepTwoRoutes.includes(routeName as string)) return 2;

  return 0;
}
</script>
